// extracted by mini-css-extract-plugin
export default {"header":"index_header_OMrOg","stickyTop":"index_stickyTop_qRmki","headerBox":"index_headerBox_hif3X","logo":"index_logo_ocj3t","botton":"index_botton_GGJfE"};